import React from 'react';
import { ShieldAlert } from 'lucide-react';

// Rappel RGPD affiché sous les champs de texte libre : limiter la saisie aux
// faits utiles et éviter les données inutiles ou sensibles sur les personnes.
// withSpellcheck : le champ propose la correction orthographique, qui envoie
// le texte à un service tiers (LanguageTool) - voir la charte.
const FreeTextNotice = ({ withSpellcheck = false, className = '' }) => (
  <p
    className={`flex items-start gap-1.5 text-xs text-amber-700 dark:text-amber-300 ${className}`}
    data-testid="free-text-notice"
  >
    <ShieldAlert className="h-3.5 w-3.5 shrink-0 mt-0.5" />
    <span>
      Ne notez que les faits utiles. N'indiquez jamais l'identité d'une personne (nom, adresse, téléphone) ni d'information sensible
      (origine, opinions, santé détaillée, antécédents, jugement) : en cas de secours, indiquez seulement la nature et les gestes réalisés.
      {withSpellcheck && ' « Corriger mes fautes » envoie le texte à un service de correction externe (LanguageTool) : ne l\'utilisez pas si le texte contient des données sensibles.'}
      {' '}<a href="/charte" target="_blank" rel="noreferrer" className="underline">En savoir plus</a>
    </span>
  </p>
);

export default FreeTextNotice;
